/**
 * Constants for ribbon component
 */
var RibbonConstants = /** @class */ (function () {
    function RibbonConstants() {
    }
    // View Tab Constants
    // Group Headers
    RibbonConstants.VIEWS_GROUP_HEADER = 'Views';
    RibbonConstants.ZOOM_GROUP_HEADER = 'Zoom';
    RibbonConstants.SHOW_GROUP_HEADER = 'Show';
    // Button IDs
    RibbonConstants.READ_ONLY_BUTTON_ID = '_read_only';
    RibbonConstants.PRINT_LAYOUT_BUTTON_ID = '_print_layout';
    RibbonConstants.WEB_LAYOUT_BUTTON_ID = '_web_layout';
    RibbonConstants.ZOOM_IN_BUTTON_ID = '_zoom_in';
    RibbonConstants.ZOOM_OUT_BUTTON_ID = '_zoom_out';
    RibbonConstants.HUNDRED_PERCENT_BUTTON_ID = '_hundred_percent';
    RibbonConstants.ONE_PAGE_BUTTON_ID = '_one_page';
    RibbonConstants.PAGE_WIDTH_BUTTON_ID = '_page_width';
    // Checkbox IDs
    RibbonConstants.RULER_CHECKBOX_ID = '_ruler';
    RibbonConstants.BOOKMARK_MARKERS_CHECKBOX_ID = '_bookmark_markers';
    RibbonConstants.NAVIGATION_PANE_CHECKBOX_ID = '_navigation_pane';
    // CSS Classes
    RibbonConstants.VIEW_GROUP_ICON_CSS = 'e-icons e-de-ctnr-view';
    RibbonConstants.ZOOM_GROUP_ICON_CSS = 'e-icons e-de-ctnr-zoom';
    RibbonConstants.READ_ONLY_ICON_CSS = 'e-de-readonly e-icons';
    RibbonConstants.PRINT_LAYOUT_ICON_CSS = 'e-de-printlayout e-icons';
    RibbonConstants.WEB_LAYOUT_ICON_CSS = 'e-de-weblayout e-icons';
    RibbonConstants.ZOOM_IN_ICON_CSS = 'e-icons e-de-ctnr-zoom-in';
    RibbonConstants.ZOOM_OUT_ICON_CSS = 'e-icons e-de-ctnr-zoom-out';
    RibbonConstants.FULL_PAGE_ICON_CSS = 'e-icons e-de-ctnr-full-page';
    RibbonConstants.PAGE_WIDTH_ICON_CSS = 'e-icons e-de-ctnr-page-width';
    return RibbonConstants;
}());
export { RibbonConstants };
